export default __webpack_public_path__ + "static/media/wealthservice.7540bc1a.png";